import React from 'react';
import './DeepBuffettLink.css';
import whyChooseImage from '../assets/images/why-choose-deepbuffet.png';

const DeepBuffettLink = () => {
  return (
    <section className="deepbuffett-link-section">
      <div className="deepbuffett-link-container">
        <div className="deepbuffett-link-content">
          <div className="deepbuffett-link-image">
            <img 
              src={whyChooseImage} 
              alt="為什麼選擇 DeepBuffett" 
              className="deepbuffett-image"
            />
          </div>
          <div className="deepbuffett-link-text">
            <h3>為什麼選擇 DeepBuffett？</h3>
            <p>
              DeepBuffett 是您投資路上的最佳夥伴，提供專業的 AI 財報分析工具，
              讓您像巴菲特一樣進行價值投資分析。我們結合最新的技術與深厚的金融知識，
              為您提供最準確、最及時的投資洞察。
            </p>
            <div className="deepbuffett-features">
              <div className="feature-item">
                <span className="feature-icon">🤖</span>
                <span>AI 智能分析</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">📊</span>
                <span>20年財務數據</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">📝</span>
                <span>逐字稿分析</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">💡</span>
                <span>投資洞察</span>
              </div>
            </div>
            <a 
              href="https://deepbuffett.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="deepbuffett-link-button"
            >
              了解更多 →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeepBuffettLink;

